module.exports = __webpack_public_path__ + "img/30.e3065403.png";